//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'MenuEsports',
  data() {
    return {
      //sports: []
    }
  },
  computed: {
    sports() {
      let sports = this.$store.state?.sports || []
      sports = sports.filter(sport => sport.category === 'esport')
      sports = sports.filter(sport => sport.event_count > 0)
      sports = sports.filter(sport => !sport.is_parent)
      return sports
    }
  },
  methods: {
    getURL(sport) {
      let prefix = '/e-sports/'
      if (this.lang === 'ro') {
        prefix = process.env.BOOKMAKER === 'netbetcom' ? '/e-sports/' : '/e-sporturi/'
      }
      return prefix + sport.translated_slug + '/'
    }
  }
}
